import { ReactElement, useCallback } from 'react';

import {
   appendTestableComponentAttributes,
   FullscreenSpinner,
   IconFillColor,
   IconSize,
   IconWrapper,
} from '@dreryk/react-components';
import { Translate, useBoolean } from '@dreryk/react-common';

import { translationKeys } from './translations';
import { AdamedExpertIcon } from './AdamedExpertIcon';
import { StyledAdamedExpertAuthenticateOrRedirectButton } from './AdamedExpertAuthenticateOrRedirectButton.styled';
import { useAdamedExpertAuthenticateCommand } from './AdamedExpertAuthenticateOrRedirectButton.hooks';
import { AdamedExpertModal } from './AdamedExpertModal';
import { AdamedExpertThemeProvider } from './AdamedExpertThemeProvider';

export const AdamedExpertAuthenticateOrRedirectButton = (): ReactElement => {
   const { execute: adamedExpertAuthenticate, loading } = useAdamedExpertAuthenticateCommand();
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);
   const authenticateOrRedirect = useCallback(() => adamedExpertAuthenticate({ openModal: openModal }), [
      adamedExpertAuthenticate,
      openModal,
   ]);
   return (
      <>
         {loading ? <FullscreenSpinner label={translationKeys.loading} /> : null}
         {modalOpened ? (
            <AdamedExpertThemeProvider>
               <AdamedExpertModal onClose={closeModal} authenticateOrRedirect={authenticateOrRedirect} />
            </AdamedExpertThemeProvider>
         ) : null}
         <StyledAdamedExpertAuthenticateOrRedirectButton
            {...appendTestableComponentAttributes(
               'AdamedExpertAuthenticateOrRedirectButton',
               'adamedExpertAuthenticateOrRedirectButton'
            )}
            onClick={authenticateOrRedirect}
         >
            <IconWrapper size={IconSize.NORMAL} testId={'adamedExpertIcon'} fillColor={IconFillColor.WHITE}>
               <AdamedExpertIcon />
            </IconWrapper>
            <Translate>{translationKeys.button}</Translate>
         </StyledAdamedExpertAuthenticateOrRedirectButton>
      </>
   );
};
